import { render, staticRenderFns } from "./UserConfig.vue?vue&type=template&id=d4c7abea&"
import script from "./UserConfig.vue?vue&type=script&lang=js&"
export * from "./UserConfig.vue?vue&type=script&lang=js&"
import style0 from "./UserConfig.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports